import { Popover } from 'radix-ui';
import { Info } from 'lucide-react';

/** What a figure is, where its numbers come from, and how it is worked out. One per metric, chart and table column. */
export interface MetricInfo { what: string; source: string; how: string }

/**
 * The ⓘ beside a metric (V2 D110). Three lines on tap: what it is, the
 * sheet or upload it comes from, how it is calculated. Nothing shows until
 * asked, so the page stays clean; nothing on the page is unexplained.
 */
export function InfoDot({ info, label }: { info: MetricInfo; label?: string }) {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button type="button" aria-label={label ? `About ${label}` : 'About this figure'} onClick={(e) => e.stopPropagation()} className="inline-flex shrink-0 rounded-full p-0.5 align-middle text-ink-muted/70 hover:bg-band hover:text-navy print:hidden">
          <Info size={13} />
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content align="start" sideOffset={6} collisionPadding={12} onClick={(e) => e.stopPropagation()} className="z-[80] w-80 max-w-[calc(100vw-1.5rem)] rounded-lg border border-line bg-white p-3 text-left text-xs shadow-xl">
          {label && <div className="mb-2 text-sm font-semibold text-navy">{label}</div>}
          <dl className="space-y-2">
            <div><dt className="font-semibold uppercase tracking-wide text-ink-muted">What</dt><dd className="mt-0.5 text-ink">{info.what}</dd></div>
            <div><dt className="font-semibold uppercase tracking-wide text-ink-muted">Source</dt><dd className="mt-0.5 text-ink">{info.source}</dd></div>
            <div><dt className="font-semibold uppercase tracking-wide text-ink-muted">How</dt><dd className="mt-0.5 text-ink">{info.how}</dd></div>
          </dl>
          <Popover.Arrow className="fill-white" />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
